import './style.scss'

import React, { JSX } from 'react'

export const SectionWorkflow = (): JSX.Element => {
    const forwardersBrokers = [
        {
            title: 'Faster cargo charter quotes',
            text: 'Reduce manual work. Turn complex cargo requests into client-ready offers ahead of the competition.',
        },
        {
            title: 'Verified operators & fleets',
            text: 'Get direct access to vetted cargo airlines and live aircraft availability beyond your personal network.',
        },
        {
            title: 'Direct chat, zero commission',
            text: 'No hidden platform fees or middleman markups. Negotiate directly with operators and keep 100% of your margin.',
        },
    ]

    const airlinesOperators = [
        {
            title: 'Monetize ferry flights & empty legs',
            text: 'Publish available aircraft and routes instantly. Capture active demand to fill empty capacity and generate revenue.',
        },
        {
            title: 'Verified, relevant requests only',
            text: 'Zero spam. Receive targeted, pre-filtered cargo inquiries from vetted brokers that match your fleet.',
        },
        {
            title: 'Centralized dashboard & email alerts',
            text: 'Manage all flights and requests in one simple interface. Never miss a deal with instant automated email notifications.',
        },
    ]

    return (
        <div id="anchor-workflow" className="section-workflow">
            <div className="section-workflow__container">
                <div className="section-workflow__top">
                    <div className="section-workflow__section-title">
                        / Platform Benefits
                    </div>
                    <h2 className="section-workflow__title">
                        {'Different roles, the same goal: '}
                        <br />
                        faster and more profitable charter bookings
                    </h2>
                </div>
                <div className="section-workflow__content">
                    <div className="section-workflow__list">
                        <ol className="section-workflow__list-broker">
                            <div className="section-workflow__list-info">
                                <div className="section-workflow__list-title">
                                    For forwarders & brokers
                                </div>
                                <div className="section-workflow__list-text">
                                    Respond to clients faster. Win more deals.
                                </div>
                            </div>
                            {forwardersBrokers.map((item) => (
                                <li key={item.title}>
                                    <div className="section-workflow__item">
                                        <div className="section-workflow__item-title">{item.title}</div>
                                        <div className="section-workflow__item-text">{item.text}</div>
                                    </div>
                                </li>
                            ))}
                        </ol>
                    </div>
                    <div className="section-workflow__list">
                        <ol className="section-workflow__list-owner">
                            <div className="section-workflow__list-title">
                                For airlines & operators
                            </div>
                            <div className="section-workflow__list-text">
                                Fill more flights. Reach the entire market.
                            </div>
                            {airlinesOperators.map((item) => (
                                <li key={item.title}>
                                    <div className="section-workflow__item">
                                        <div className="section-workflow__item-title">{item.title}</div>
                                        <div className="section-workflow__item-text">{item.text}</div>
                                    </div>
                                </li>
                            ))}
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    )
}
